module.exports = __webpack_public_path__ + "media/images/logos/bg-a1fe665685dca20b98e13a28ddfc602d.png";